import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledCheckbox = styled.input<{ $hasError?: boolean; $borderColor?: string }>`
  width: 24px;
  height: 24px;
  border: 1px solid ${({ $hasError, $borderColor }) => ($hasError ? '#ef4444' : $borderColor)};
  border-radius: 0.25rem;
`;

export const StyledLabel = styled.label<{ labelClass?: string; $colors?: string }>`
  font-size: 0.875rem; // text-sm
  color: ${({ $colors }) => $colors}};
`;

export const ErrorMessage = styled.span`
  font-size: 0.75rem;
  color: #ef4444;
`;
